import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const alertSlice = createSlice({
  name: 'alerts',
  initialState: [],
  reducers: {
    // If you mean to create/show an alert use showAlert from utils instead
    addAlert(state, action) {
      state.push({ id: uuidv4(), ...action.payload });
    },
    // Removal of alerts is done automatically, this does not to be called manually when creating alerts
    removeAlert(state, action) {
      return state.filter(alert => alert.id !== action.payload);
    },
  },
});

export const { addAlert, removeAlert } = alertSlice.actions;
export default alertSlice.reducer;
